/**
 * Route Constants
 *
 * Application route paths as constants.
 * Use these instead of hardcoding paths in components.
 *
 * @module routes/constants
 */

/**
 * Application route paths.
 */
export const ROUTES = {
  /** Public landing page */
  LANDING: '/',
  /** Admin users management page */
  USERS: '/users',
  /** Authenticated user's own profile page */
  PROFILE: '/profile',
  /** No access page for non-admin users */
  NO_ACCESS: '/no-access',
  /** Error page */
  ERROR: '/error',
} as const;
